import { useMutation, useQuery } from "react-query";
import { invalidateHasActiveProjectsTemplate, queryClient } from "~/repository/index";
import Angie from "~/utils/angie";
import { classTypeToUrlSlugResolver } from "~/utils/classTypeToUrlSlugResolver";
import { fetch } from "~/utils/fetch";
import { param } from "~/utils/url_helper";

export const useTrashScreen = (filters) => {
  return useQuery({
    queryKey: ["trash", filters],
    queryFn: ({ signal }) => {
      const requestAttrs = {};

      if (filters?.projectFilter?.length) {
        requestAttrs["project"] = filters.projectFilter;
      }

      if (filters?.deletedByFilter?.length) {
        requestAttrs["deleted_by"] = filters.deletedByFilter;
      }

      if (filters?.typeFilter?.length) {
        requestAttrs["type"] = filters.typeFilter;
      }

      const requestAttrsEncoded = param(requestAttrs) && "?" + param(requestAttrs);

      return fetch({
        url: `${Angie.api_url}/trash/for-screen${requestAttrsEncoded}`,
        signal,
      });
    },
  });
};

export const useAvailableTrashFilters = (config) => {
  return useQuery({
    ...config,
    queryKey: ["trash-filters"],
    queryFn: ({ signal }) =>
      fetch({
        url: `${Angie.api_url}/trash/filters`,
        signal,
      }),
  });
};

export const useRestoreFromTrashMutation = (object_class, object_id) => {
  return useMutation({
    mutationFn: () =>
      fetch({
        url: `${Angie.api_url}/restore-from-trash/${classTypeToUrlSlugResolver(object_class)}/${object_id}`,
        method: "PUT",
      }),
    onSuccess: () => {
      if (object_class === "ProjectTemplate") {
        const cachedHasActiveProjectsTemplates = queryClient.getQueryData(["has-active-templates"]);
        if (cachedHasActiveProjectsTemplates?.has_active_templates === false) {
          invalidateHasActiveProjectsTemplate();
        }
      }
    },
  });
};

export const usePermanentlyDeleteMutation = (object_class, object_id) => {
  return useMutation({
    mutationFn: () =>
      fetch({
        url: `${Angie.api_url}/permanently-delete/${classTypeToUrlSlugResolver(object_class)}/${object_id}`,
        method: "DELETE",
      }),
  });
};

export const useEmptyTrashMutation = () => {
  return useMutation({
    mutationFn: () =>
      fetch({
        url: `${Angie.api_url}/trash`,
        method: "DELETE",
      }),
  });
};
